// iter110n-3 fix (v2) · CEO 2026-09-28 · Open an authenticated PDF endpoint.
// Cross-platform strategy (works on mobile Safari, Android Chrome,
// Samsung Internet, desktop Chrome, Firefox) : inject the JWT as a
// query-string parameter so that a plain `window.open()` (or `<a href>`)
// works — the browser doesn't need to send an Authorization header.
// Backend endpoints marked as query-flex accept `?token=<jwt>`.
import { toast } from "sonner";
import { tokenStore, API_BASE } from "./api";

export function openAuthedPdf(url) {
    const token = tokenStore.get();
    if (!token) {
        toast.error("Session expirée — reconnecte-toi");
        return;
    }
    // `url` is passed as an axios-relative path (e.g. "/procedures/versions/xxx/pdf").
    // Build the absolute URL against API_BASE and append the token.
    const base = url.startsWith("http") ? url : `${API_BASE}${url}`;
    const sep = base.includes("?") ? "&" : "?";
    const fullUrl = `${base}${sep}token=${encodeURIComponent(token)}`;
    // Open synchronously inside the click handler — no `await` needed here,
    // so the user-gesture context is preserved on every browser.
    window.open(fullUrl, "_blank", "noopener,noreferrer");
}
